import { render } from "./webhooks.vue?vue&type=template&id=ab02e348"
import script from "./webhooks.vue?vue&type=script&lang=js"
export * from "./webhooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__